const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VISITOR_KEY = "adaptience_visitor_id";

export const getVisitorId = () => {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
};

export const track = (type, stage, meta) => {
  try {
    const body = { type, visitor_id: getVisitorId() };
    if (stage) body.stage = stage;
    if (meta && meta.simulation_id) body.simulation_id = meta.simulation_id;
    if (meta && meta.session_id) body.session_id = meta.session_id;
    if (meta && meta.report_id) body.report_id = meta.report_id;
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // no-op: analytics must never break the experience
  }
};
